import React, { useState } from "react";
import "./assets/css/header.css";
import "../src/assets/css/login.css";
import styles from "../src/assets/css/LoadingComponent.module.css";

import logoImage from "../src/assets/logo4.svg";
import emailImage from "../src/assets/emailplaceholder.svg";
import passwordImage from "../src/assets/passwordplaceholder.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "./config";
import { BsArrowRight } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { addUser } from "./store/slices/UserSlice";
import { useMediaQuery } from "react-responsive";
import { SignInHeader } from "./components/Header/SignInHeader";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { ErrorHandlingComponent } from "./ErrorHandlingComponent";
import Auth0SocialLoginTiles from "./Auth0SocialLoginTiles";

function Login() {
  const invaidCredDivStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  /** Header “Sign up” — role choice (job seeker vs employer). */
  const signupHeaderClick = () => {
    navigate("/register");
  };

  const forgotPasswordClick = () => {
    navigate("/forgot_password");
  };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [fetchErrorMessage, setFetchErrorMessage] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const passwordVisible = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleCheckboxChange = () => {
    setRememberMe(!rememberMe);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSignIn();
    }
  };

  const handleSignIn = (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading(true);
    setIsPasswordVisible(false);
    setError([]);
    const payload = {
      email,
      password,
    };

    axios
      .post(`${BASE_URL}/login`, payload)
      .then(async (response) => {
        setLoading(false);
        if (response.data.status === 200) {
          const preLogin = localStorage.getItem("login");
          localStorage.clear();
          const user = response.data.user;
          const userableType = user.userable_type;
          const userId = user.id;

          localStorage.setItem("userId", userId);
          localStorage.setItem("userable_type", userableType);
          localStorage.setItem("access_token", response.data.access_token);

          if (userableType === "App\\Models\\JobSeeker") {
            localStorage.setItem("jobSeekerId", user.userable_id);
          } else {
            localStorage.setItem("employerId", user.userable_id);
          }

          if (rememberMe) {
            const expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 30);
            localStorage.setItem("expiry_date", expiryDate.toISOString());
          } else {
            const expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 1);
            localStorage.setItem("expiry_date", expiryDate.toISOString());
          }

          await dispatch(addUser(user));

          if (userableType === "App\\Models\\JobSeeker") {
            if (preLogin === "0") {
              localStorage.setItem("login", "0");
              navigate("/login-attempt");
            } else {
              navigate("/job_seeker_dashboard");
            }
          } else {
            navigate("/employer_dashboard");
          }
        } else {
          setError(response.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        setFetchError(true);
        setFetchErrorMessage(err);
        setError(err.response?.data || { msg: "Sign in failed" });
      });
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  const linkButtonStyle = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    color: "inherit",
    font: "inherit",
    textDecoration: "underline",
  };

  const logoButtonStyle = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
  };

  return (
    <div>
      <div className="nav bg-white">
        <div className="container-fluid">
          <div className="row navpad">
            <div className="d-flex justify-content-between">
              <div className="col-lg-4 logosearch">
                <button
                  type="button"
                  onClick={handleLogoClick}
                  style={logoButtonStyle}
                  aria-label="Home"
                >
                  <img src={logoImage} alt="Logo" />
                </button>
              </div>
              <div className="col-lg-8 d-flex justify-content-end align-items-center">
                {isTabletOrMobile ? (
                  <SignInHeader
                    text="SIGN UP"
                    handlerClick={signupHeaderClick}
                  />
                ) : (
                  <div className="postbtn">
                    <button type="submit" onClick={signupHeaderClick}>
                      SIGN UP
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mainbg">
        <div className="form">
          <div className="formdata">
            <h2>Sign In</h2>
            <p>Please provide your login information</p>

            <div className="emailinfo">
              <img src={emailImage} alt="" />
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            {error.email && (
              <span className="text-danger">{error.email}</span>
            )}
            <div className="emailinfo passwordinfo">
              <img src={passwordImage} alt="" />
              <input
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <div className="eye-icon-container" onClick={passwordVisible}>
                {isPasswordVisible ? (
                  <IoEyeOutline className="eye-icon" size={24} />
                ) : (
                  <IoEyeOffOutline className="eye-icon" size={24} />
                )}
              </div>
            </div>
            {error.password && (
              <span className="text-danger">{error.password}</span>
            )}
            <div className="formforget">
              <div>
                <input
                  type="checkbox"
                  id="remember"
                  name="remember"
                  checked={rememberMe}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="remember" className="checkbox-label">
                  Remember me on this device for 30 days
                </label>
                <br />
              </div>

              <div>
                <br />
                <p>
                  Having trouble signing in? Use{" "}
                  <button
                    type="button"
                    onClick={forgotPasswordClick}
                    style={linkButtonStyle}
                  >
                    Forgot password
                  </button>
                  .
                </p>
              </div>
            </div>
            <div style={invaidCredDivStyle}>
              <span className="text-danger">{error.msg}</span>
            </div>
            <div className="formbtn">
              <button type="button" onClick={handleSignIn}>
                Login
                {loading && (
                  <div className={styles.loadingOverlay}>
                    <div className={styles.loadingSpinner} />
                  </div>
                )}
              </button>

              <Auth0SocialLoginTiles
                layout="inline"
                rememberMe={rememberMe}
                marginTop={10}
              />

              <p style={{ marginTop: 10, textAlign: "center" }}>
                Don&apos;t have an account?{" "}
                <button
                  type="button"
                  onClick={() => navigate("/register")}
                  style={linkButtonStyle}
                >
                  Sign up
                </button>
              </p>
              <p style={{ textAlign: "center" }}>
                <button
                  type="button"
                  onClick={() => navigate("/")}
                  style={linkButtonStyle}
                >
                  Back to home <BsArrowRight />
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
      {fetchError && <ErrorHandlingComponent error={fetchErrorMessage} />}
    </div>
  );
}

export default Login;
